import Env from './env';
let prot = window.location.protocol;
let origin = '';
if (!window.location.origin) {
  origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
} else {
  origin = window.location.origin
}
let prefix = origin.split(":")[1];

let config = {
    env: Env,
    token_header_name: 'x-bear',
    token_cookie_name: 'agh_token_test',
    access_token_cookie_name: 'cas_v1',
    url: {
        'logout': '/member/logout'
    },
    default_domin: prot+process.env.VUE_APP_DEFAULT_DOMAIN,
    b_index_domin: process.env.VUE_APP_B_INDEX_DOMAIN ? (prot+process.env.VUE_APP_B_INDEX_DOMAIN) : (prot + prefix),
    intXmlTpl: process.env.VUE_APP_INT_XML_TPL,
    delUserTpl: process.env.VUE_APP_DEL_USER_TPL,
    birthdaywallXmlTpl: process.env.VUE_APP_BIRTHDAYWALL_XML_TPL,
    sendXmlTpl: process.env.VUE_APP_SEND_XML_TPL,
    selfdeliverXmlTpl: process.env.VUE_APP_SELFDELIVER_XML_TPL,

    m_domin: prot+process.env.VUE_APP_M_DOMAIN,
    apps_domain: prot+process.env.VUE_APP_APPS_DOMAIN,
    cas_domin: prot+process.env.VUE_APP_CAS_DOMAIN,
    agh_cas_domin: prot+process.env.VUE_APP_AGH_CAS_DOMAIN,
    card3Host: prot+process.env.VUE_APP_CARD3_HOST,
    api_domin: prot+process.env.VUE_APP_API_DOMAIN,
    ddguanhuai_domin: prot+process.env.VUE_APP_DDGH_DOMAIN,
    qr_api_domain:prot+process.env.VUE_APP_QR_API_DOMAIN,

    app_key: process.env.VUE_APP_KEY,
    key_words : '点滴'
};
if (Env == 'ding') {
    config.url= {
        'logout': 'http://apps-ding.test.care001.cn/api/fe/v1/private/p/member/logout'
      }
}
if(Env == 'production'){
    config.token_cookie_name = 'agh_token';
}
console.log('Env: %s, prefix: %s, config: %s', Env, prefix, JSON.stringify(config))

export default config;
